
export default {
  name: 'AccordionComponent',
  // TODO: write the type of each prop
  // eslint-disable-next-line
  props: ['_type', '_id', 'title', 'select', 'close'],

  data() {
    return {
      isActive: false
    };
  },

  watch: {
    close() {
      this.isActive = false;
    }
  },

  methods: {
    selected() {
      this.select(this._uid);
      this.$nextTick(() => (this.isActive = !this.isActive));
    },
    enter(element) {
      requestAnimationFrame(() => {
        element.style.maxHeight = element.scrollHeight + 'px';
      });
    },
    afterenter(element) {
      requestAnimationFrame(() => {
        element.style.maxHeight = element.scrollHeight + 'px';
      });
    },
    leave(element) {
      requestAnimationFrame(() => {
        element.style.maxHeight = 0 + 'px';
      });
    }
  }
};
